// extracted by mini-css-extract-plugin
export default {"svg":"Footer-module__[local]___9dHKL","footer":"Footer-module__[local]___LA+rQ"};